import styled from 'styled-components';

export const DesktopOnly = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none !important;
  }
`;

export const MobileOnly = styled.div`
  display: none !important;

  @media (max-width: 768px) {
    display: block !important;
  }
`;

export const MobileCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 2px 24px;
`;

export const MobileCard = styled.article`
  background: #fff;
  border: 1px solid ${({ theme }) => theme.PrimaryBorderColor || '#e5e7eb'};
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  &:active {
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
  }
`;

export const MobileCardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
`;

export const MobileCardIdentity = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  flex: 1;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;

export const MobileCardTitle = styled.div`
  min-width: 0;
  flex: 1;

  .eyebrow {
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.PrimaryGrey || '#6b7280'};
    margin-bottom: 2px;
  }

  .title {
    display: block;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.35;
    color: ${({ theme }) => theme.PrimaryColor || '#2563eb'};
    word-break: break-word;
  }

  .subtitle {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${({ theme }) => theme.PrimaryGrey || '#6b7280'};
    word-break: break-word;
  }
`;

export const MobileCardMeta = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 4px;
  padding-top: 10px;
  border-top: 1px solid ${({ theme }) => theme.PrimaryFade || '#f3f4f6'};

  .meta-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    font-size: 13px;
  }

  .meta-label {
    color: ${({ theme }) => theme.PrimaryGrey || '#6b7280'};
    flex-shrink: 0;
  }

  .meta-value {
    text-align: right;
    word-break: break-word;
    font-weight: 500;
    color: ${({ theme }) => theme.PrimaryFontColor || '#111827'};
  }
`;

export const MobileCardActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
`;

export const MobileCardSelect = styled.div`
  padding-top: 2px;
  flex-shrink: 0;
`;
